var map = {
	"./sensorencoders/AERIS-v0.2Downlink": 1234,
	"./sensorencoders/AERIS-v0.2Downlink.js": 1234,
	"./sensorencoders/BREEZE-v1.1Downlink": 1486,
	"./sensorencoders/BREEZE-v1.1Downlink.js": 1486,
	"./sensorencoders/BREEZE-v2.1Downlink": 5959,
	"./sensorencoders/BREEZE-v2.1Downlink.js": 5959,
	"./sensorencoders/CHICKADEE-v2.7Downlink": 3310,
	"./sensorencoders/CHICKADEE-v2.7Downlink.js": 3310,
	"./sensorencoders/COMFORT-VIVID-v2.2Downlink": 2551,
	"./sensorencoders/COMFORT-VIVID-v2.2Downlink.js": 2551,
	"./sensorencoders/COMFORT-VIVID-v3.1Downlink": 9863,
	"./sensorencoders/COMFORT-VIVID-v3.1Downlink.js": 9863,
	"./sensorencoders/COMFORT-VIVID-v4.0Downlink": 5739,
	"./sensorencoders/COMFORT-VIVID-v4.0Downlink.js": 5739,
	"./sensorencoders/COMFORT-VIVID-v4.2Downlink": 6680,
	"./sensorencoders/COMFORT-VIVID-v4.2Downlink.js": 6680,
	"./sensorencoders/COMFORT-VIVID-v4.3Downlink": 5538,
	"./sensorencoders/COMFORT-VIVID-v4.3Downlink.js": 5538,
	"./sensorencoders/HARMONY-v0.3Downlink": 3419,
	"./sensorencoders/HARMONY-v0.3Downlink.js": 3419,
	"./sensorencoders/HARMONY-v0.4Downlink": 4881,
	"./sensorencoders/HARMONY-v0.4Downlink.js": 4881,
	"./sensorencoders/HARMONY-v0.6Downlink": 9230,
	"./sensorencoders/HARMONY-v0.6Downlink.js": 9230,
	"./sensorencoders/Industrial-Transceiver-1wire-v1.11Downlink": 1248,
	"./sensorencoders/Industrial-Transceiver-1wire-v1.11Downlink.js": 1248,
	"./sensorencoders/Industrial-Transceiver-v2.1Downlink": 4253,
	"./sensorencoders/Industrial-Transceiver-v2.1Downlink.js": 4253,
	"./sensorencoders/KIWI-CLOVER-v2.0Downlink": 9217,
	"./sensorencoders/KIWI-CLOVER-v2.0Downlink.js": 9217,
	"./sensorencoders/MEMO-(demo)Downlink": 3171,
	"./sensorencoders/MEMO-(demo)Downlink.js": 3171,
	"./sensorencoders/ORCA-v0.14Downlink": 7542,
	"./sensorencoders/ORCA-v0.14Downlink.js": 7542,
	"./sensorencoders/ORCA-v1.0Downlink": 5500,
	"./sensorencoders/ORCA-v1.0Downlink.js": 5500,
	"./sensorencoders/ROBIN-FINCH-v1.0Downlink": 8139,
	"./sensorencoders/ROBIN-FINCH-v1.0Downlink.js": 8139,
	"./sensorencoders/SEAL-v2.1Downlink": 6499,
	"./sensorencoders/SEAL-v2.1Downlink.js": 6499,
	"./sensorencoders/SEAL-v2.2Downlink": 7672,
	"./sensorencoders/SEAL-v2.2Downlink.js": 7672,
	"./sensorencoders/SPARROW-PELICAN-v2.8Downlink": 6714,
	"./sensorencoders/SPARROW-PELICAN-v2.8Downlink.js": 6714,
	"./sensorencoders/SPARROW-PELICAN-v3.1Downlink": 5626,
	"./sensorencoders/SPARROW-PELICAN-v3.1Downlink.js": 5626,
	"./sensorencoders/STORK-v2.0Downlink": 7557,
	"./sensorencoders/STORK-v2.0Downlink.js": 7557,
	"./sensorencoders/STORK-v2.1Downlink": 9987,
	"./sensorencoders/STORK-v2.1Downlink.js": 9987,
	"./sensorencoders/STORK-v2.2Downlink": 3078,
	"./sensorencoders/STORK-v2.2Downlink.js": 3078,
	"./sensorencoders/TUNDRA-v2.3Downlink": 7272,
	"./sensorencoders/TUNDRA-v2.3Downlink.js": 7272,
	"./sensorencoders/eBeat-v1.0Downlink": 3641,
	"./sensorencoders/eBeat-v1.0Downlink.js": 3641,
	"./sensorencoders/eBeat-v1.2Downlink": 8420,
	"./sensorencoders/eBeat-v1.2Downlink.js": 8420,
	"./sensorencoders/eBeat-v1.xDownlink": 9329,
	"./sensorencoders/eBeat-v1.xDownlink.js": 9329,
	"./sensorencoders/eDoctor-v0.15Downlink": 5436,
	"./sensorencoders/eDoctor-v0.15Downlink.js": 5436,
	"./sensorencoders/eDoctor-v1.2Downlink": 1578,
	"./sensorencoders/eDoctor-v1.2Downlink.js": 1578,
	"./sensorencoders/eDoctor-v1Downlink": 8657,
	"./sensorencoders/eDoctor-v1Downlink.js": 8657
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2358;